module.exports = __webpack_public_path__ + "assets/img/person_icon_c.28961c2a.png";